/** Gets a concatenated street name that's typically needed by Salesforce.
 * @param address1 The primary address.
 * @param address2 The secondary (optional) address.
 * @returns If the secondary address is provided, the concatenation of address1 and address2 is returned. Otherwise only address1 is returned.
 */
export const getStreet = (address1: string, address2?: string) =>
  address2 ? [address1, address2].join('\n') : address1;
